import { pubSub } from 'utils/pubSub';

import { SidekickQuestion } from './sidekick.types';

/**
 * Opens the Sidekick and sends a prompt as the next message. When a
 * conversation is already running, the prompt is appended to it.
 *
 * Pass a prompt to send it straight away, or a question to ask the user for
 * context first and build the prompt from their answer.
 */
export const askSidekick = (request: string | SidekickQuestion): void => {
  pubSub.publish(
    'askMimSidekick',
    typeof request === 'string' ? { prompt: request } : request,
  );
};
